import { ChevronDown, Folder, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function TagManagementTableActions({
  selectedIds,
  canEditTag,
  canDeleteTag,
  onBulkDelete,
  onBulkUpdateCategory,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        disabled={!selectedIds?.length}
        className={buttonVariants({ variant: "outline" })}
      >
        Actions
        <ChevronDown />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        <DropdownMenuGroup>
          {canEditTag && (
            <DropdownMenuItem onClick={() => onBulkUpdateCategory(selectedIds)}>
              <Folder />
              Bulk Update Category
            </DropdownMenuItem>
          )}
          {canDeleteTag && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => onBulkDelete(selectedIds)}
            >
              <Trash2 />
              Delete Tag(s) ({selectedIds?.length ?? 0})
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
